"use client";
import Script from "next/script";
export default function LemonPay({ handler }: any) {
    function lemonLoaded() {
        //@ts-expect-error
        window.lemonSqueezyAffiliateConfig = { store: "doras" };
        //@ts-expect-error
        window.createLemonSqueezy();
        //@ts-expect-error
        LemonSqueezy.Setup({
            eventHandler: (event: any) => {
                if (handler) {
                    handler(event);
                }
            },
        });
        const script = document.createElement("script");
        script.src = "https://lmsqueezy.com/affiliate.js";
        script.defer = true;
        document.head.appendChild(script);
    }

    return (
        <Script
            src="https://app.lemonsqueezy.com/js/lemon.js"
            onLoad={lemonLoaded}
        ></Script>
    );
}
